/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const stageEnumSchema = z
	.enum(["waiting_payment", "accepted", "cooking", "ready", "on_way", "delivered", "completed", "cancelled", "failed"])
	.describe(
		"* `waiting_payment` - Ожидает оплаты\n* `accepted` - Принят\n* `cooking` - Готовится\n* `ready` - Собран\n* `on_way` - Курьер в пути\n* `delivered` - Доставлен\n* `completed` - Выдан\n* `cancelled` - Отменён\n* `failed` - Не удалось оформить",
	);
